//
// IMPORTANT: This file is a schema and must be managed with extreme care.
// See types/schema/README.md for more information.
//

export const PROPOSAL_BUILDER_SCHEMA_VERSION = '1.0'

export interface ProposalBuilderConfig {
  // This is an abuse of page configs to store the investment guidelines
  // for the proposal builder in advance of the Edward Jones demo.
  investmentGuidelines: string
}
